import { ImageOptions } from './type'

const isSupportWebp = () => {
  return (
    typeof window !== 'undefined' &&
    0 == document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp')
  )
}

const positionMap: any = new Map([
  ['nw', 'NorthWest'],
  ['north', 'North'],
  ['ne', 'NorthEast'],
  ['west', 'West'],
  ['center', 'Center'],
  ['east', 'East'],
  ['sw', 'SouthWest'],
  ['south', 'South'],
  ['se', 'SouthEast'],
])

const isSupportWebpStatic = isSupportWebp()

export const processImageByAli = (options: Array<ImageOptions>, isGif: boolean) => {
  if (isGif) return ''
  let s: string = isSupportWebpStatic && !isGif ? '/format,webp' : ''
  for (let i = 0; i < options.length; i++) {
    const action = options[i]
    let params = ''
    switch (action.mode) {
      case 'crop':
        params += `${action.width ? ',w_' + action.width : ''}${
          action.height ? ',h_' + action.height : ''
        }${positionMap.has(action.position) ? ',g_' + action.position : ',g_center'}`
        s += '/crop' + params
        break
      case 'resize':
        params += `${action.width ? ',w_' + action.width : ''}${
          action.height ? ',h_' + action.height : ''
        }`
        if (params) {
          s += '/resize' + params
        }
        break
      default:
        break
    }
  }
  return s
}

export const processVideoByAli = (options: Array<ImageOptions>) => {
  let s = ''
  const snapAction = options.find((a) => a.mode === 'snap')
  if (snapAction) {
    s += `/snapshot${snapAction.t ? ',t_' + snapAction.t * 1000 : ',t_000'}${
      snapAction.width ? ',w_' + snapAction.width : ''
    }${snapAction.height ? ',h_' + snapAction.height : ''}`
  }
  return s
}

export const processImageByQiniu = (options: Array<ImageOptions>, isGif: boolean) => {
  if (isGif) return ''
  let s: string = isSupportWebp() && !isGif ? '/format/webp' : ''
  for (let i = 0; i < options.length; i++) {
    const action = options[i]
    let params = ''
    switch (action.mode) {
      case 'crop':
        if (action.width || action.height) {
          params += `/crop/${action.width || ''}x${action.height || ''}`
        }
        s +=
          `/gravity/${
            positionMap.has(action.position) ? positionMap.get(action.position) : 'Center'
          }` + params
        break
      case 'resize':
        if (action.width || action.height) {
          params += `/${action.width || ''}x${action.height || ''}`
        }
        if (params) {
          s += '/thumbnail' + params
        }
        break
      default:
        break
    }
  }
  return s
}

export const processVideoByQiniu = (options: Array<ImageOptions>) => {
  let s = '/jpg'
  const snapAction = options.find((a) => a.mode === 'snap')
  if (snapAction) {
    s += `${snapAction.t ? '/offset/' + snapAction.t : '/offset/000'}${
      snapAction.width ? '/w/' + snapAction.width : ''
    }${snapAction.height ? '/w/' + snapAction.height : ''}`
  }
  return s
}
